import { render } from "./ListIzinSetujuView.vue?vue&type=template&id=0030c2a8"
import script from "./ListIzinSetujuView.vue?vue&type=script&lang=js"
export * from "./ListIzinSetujuView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__